import { CallStats, StatsCommon } from '#common/stats';
export class ObjectStoreStats extends StatsCommon {
    bucketExists;
    createBucket;
    deleteBucket;
    headObject;
    getObject;
    putObject;
    deleteObject;
    listObjects;
    constructor(log) {
        super();
        this.bucketExists = new CallStats('bucketExists', log);
        this.createBucket = new CallStats('createBucket', log);
        this.deleteBucket = new CallStats('deleteBucket', log);
        this.headObject = new CallStats('headObject', log);
        this.getObject = new CallStats('getObject', log);
        this.putObject = new CallStats('putObject', log);
        this.deleteObject = new CallStats('deleteObject', log);
        this.listObjects = new CallStats('listObjects', log);
    }
}
